import { render, staticRenderFns } from "./ChangeTaskOwner.vue?vue&type=template&id=5657f28c&scoped=true"
import script from "./ChangeTaskOwner.vue?vue&type=script&lang=js"
export * from "./ChangeTaskOwner.vue?vue&type=script&lang=js"
import style0 from "./ChangeTaskOwner.vue?vue&type=style&index=0&id=5657f28c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5657f28c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/brkt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5657f28c')) {
      api.createRecord('5657f28c', component.options)
    } else {
      api.reload('5657f28c', component.options)
    }
    module.hot.accept("./ChangeTaskOwner.vue?vue&type=template&id=5657f28c&scoped=true", function () {
      api.rerender('5657f28c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/components/ChangeTaskOwner.vue"
export default component.exports